"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const react_1 = __importDefault(require("react"));
const ValueBandsToolTip = (props) => {
    const { inverseColor } = props;
    return (react_1.default.createElement(CustomToolTip_1.default, { type: '?', inverse: inverseColor, info: 'This is the estimated value of the unmatched usages ' +
            'within this recording group. The values bands are: ' +
            ' $ = less than one dollar $$ = $1.00 to $10.00 $$$ = $10.01 to $50.00' +
            ' $$$$ = $50.01 to $250.00 $$$$$ = $250.01 and above' }));
};
exports.default = ValueBandsToolTip;
